<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17MsE9r/tc-custom/9780814347447.jpg?1726073151612" alt="This image is the cover for the book The Americans, TV Milestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Americans, TV Milestones
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>Explores <i>The Americans</i> as a groundbreaking series that brilliantly merged the spy genre and domestic melodrama.</b> </p><p>Based on the actual KGB strategy of planting "illegals" into American life during the Cold War, <i>The Americans</i> (FX 2013–2018) focuses on Philip and Elizabeth Jennings (Matthew Rhys and Kerri Russell), Soviet spies posing as middlebrow travel agents in the Virginia suburbs. Groundbreaking and unsettling, <i>The Americans</i> spins its stories of espionage, violence, and politics around narratives of marriage, romance, bromance, and family. Exploring the series' bold merger of the spy genre and domestic melodrama, author Linda Mizejewski focuses on the characters and relationships that made this series memorable: the extraordinary women who defy the femme fatale stereotype of the spy genre, the conflicted men, and perhaps most shockingly, the children who are both victims and provocateurs</p><p>Do viewers of this Cold War thriller root for "the good guys"—the American agents in pursuit of the Jennings—or for the Jennings themselves, the attractive couple whose personal stories compel us even as they plot the takedown of the United States? Mizejewski argues for the importance of <i>The Americans'</i> portrayal of 1980s suburban life as a microcosm of the moral complexities of citizenship and national identity. Drawing on television studies and feminist media theory, this book examines the series' seamless loop of espionage violence and family melodrama, as well as its savvy uses of 1980s pop culture and music. Far from invoking nostalgia, the replication of the 1980s "look" invokes uncertainties about how, exactly, we should see Reagan's America and the Cold War. Yet the appeal of this series rests on solid footing in the Americanism it both critiques and espouses. Mizejewski examines <i>The Americans'</i> struggles with this ambiguity and with the contradictions of identity, gender, marriage, and the meanings of home.</p><p>Everyone from scholars and students of television and media studies, genre studies, gender and sexuality studies, and popular culture, to superfans who can't believe the show is over will revel in this highly approachable and fun read.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Mizejewski
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?412cf78b